import React from "react";
import Image from "next/image";

export default function SignUpIn() {
  return (
    <div className="signup-hero-content">
      <div className="signup-hero-badge">
        <span className="signup-hero-badge-dot" aria-hidden />
        Agentic AI · Built for Finance Teams
      </div>

      <h1 className="signup-hero-title">
        AI-Powered Customer &amp; Vendor Ledger{" "}
        <em className="signup-hero-title-accent">Reconciliation</em>
      </h1>

      <p className="signup-hero-copy">
        Manual reconciliation delays resolution, hurts cash flow and strains
        relationships. <strong>OneCap</strong> fixes it in{" "}
        <strong>minutes</strong>.
      </p>

      <div className="signup-hero-media">
        <Image
          src="/Ledger workflow.png"
          alt="Ledger reconciliation workflow"
          width={720}
          height={400}
          priority
        />
      </div>

      <div className="signup-hero-cta">
        <a
          href="https://onecap.in/book-a-demo"
          className="signup-hero-cta-btn"
        >
          Book a Demo
          <svg
            width="15"
            height="15"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.4"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden
          >
            <path d="M5 12h14" />
            <path d="m12 5 7 7-7 7" />
          </svg>
        </a>
      </div>
    </div>
  );
}
